(async () => {

  if (!customElements.get('just-bought-notification')) {

    class JustBoughtNotification extends HTMLElement {
      constructor() {
        super();

        this.options = {
          heading: "Someone just bought this product",
          cities: [],
          visible_after_seconds: 30,
          seconds_visible: 5,
          collection: null,
          enabled_desktop: true,
          enabled_mobile: false
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);
          if (jsonOptions) {
            this.options = {
              ...this.options,
              ...jsonOptions
            }
          }
        }

        // split cities to array
        if (typeof this.options.cities == 'string') {
          this.options.cities = this.options.cities.split(',');
        }

        // trim array items
        this.options.cities = this.options.cities.map(el => el.trim());

        // Check if a collection is connected.
        if (!this.options?.collection && this.options.collection == null) {
          return false;
        }

        // Selectors
        this.selectors = {
          notification: this.querySelector('[data-notification]'),
          image: this.querySelector('[data-notification-image]'),
          heading: this.querySelector('[data-notification-heading]'),
          title: this.querySelector('[data-notification-title]'),
          close: this.querySelector('[data-notification-close]')
        }

        // Start Just bought notification loop
        this.loop();

        // Close event
        this.selectors.close.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });

        // Resize event
        window.addEventListener('resize', async () => {
          let storage = sessionStorage.getItem('just-bought-notification');
          if (!this.running && storage != 'hide'){
            await this.wait(this.options.seconds_visible * 1000);
            this.loop();
          }
        });

      }

      /**
       * Get section inner html
       * @param amount { integer }: milliseconds to wait
       * @returns selector { promise }: waiting time
       */
      wait(amount = 0) {
        return new Promise(resolve => {

          // Timer variable
          let timer = null;

          // Start timer function
          const startTimer = () => {
            timer = setTimeout(() => {
              this.selectors.notification.removeEventListener('mouseenter', stopTimer);
              this.selectors.notification.removeEventListener('mouseleave', startTimer);
              resolve();
            }, amount);
          }

          // Stop timer function
          const stopTimer = () => {
            clearTimeout(timer);
          }

          // Start timer
          startTimer();

          // Mouse events, pause fade out
          this.selectors.notification.addEventListener('mouseenter', stopTimer);
          this.selectors.notification.addEventListener('mouseleave', startTimer);

        });
      }

      /**
       * Get section inner html
       * @param html { object }: html string
       * @param selector { string }: html selector
       * return { DOM }: DOM object with requested html
       */
      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }

      /**
       * Transform url to image HTML
       * @param image { object }: image object
       * @returns { string }: html string
       */
      formatImage(image) {

        // Return fallback image if no imaee found
        if (!image) {
          return `
            <figure class="img img--wrapper">
              <img loading="lazy" alt="${image.alt}" width="342" height="422" src="http://cdn.shopify.com/s/images/admin/no-image-compact.gif">
            </figure>
          `;
        }

        // Build image
        return `
          <figure class="img img--wrapper ${image.class}">
            <picture>
              <img
                ${image.lazy ? 'loading="lazy"' : ''}
                alt="${image.alt}"
                width="${image.size.split('x')[0]}"
                height="${image.size.split('x')[1]}"
                src="${image.url.replace(/\/(.*)\.(\w{2,4})/g, '/$1_crop_center.$2')}"
                srcset="${image.url.replace(/\/(.*)\.(\w{2,4})/g, '/$1_crop_center.$2')} 1x, ${image.url.replace(/\/(.*)\.(\w{2,4})/g, '/$1_crop_center@2x.$2')} 2x"
              >
            </picture>
          </figure>
        `;
      }

      /**
       * Get a random product
      */
      getRandomProduct() {
        let product = this.products.sort(() => 0.5 - Math.random())[0];
        if (!product.available) {
          return this.getRandomProduct();
        }
        return product;
      }

      /**
       * Fetch product data
       */
      getProducts() {
        return new Promise((resolve, reject)=>{
          try {
            (async () => {
              let products = await fetch(`${this.options.collection.url}?view=just-bought`);
                  products = await products.text();
                  products = this.getSectionInnerHTML(products, '[data-product-json]')
                  products =  JSON.parse(products);
              resolve(products);
            })();
          } catch (error) {
            reject(error);
          }
        });
      }

      /**
       * Loop to show just bought notification
       */
      async loop() {

        // Is running loop?
        this.running = true;

        // Stop if not enabled on screen size
        if (!this.options.enabled_mobile && window.innerWidth <= 767) {
          this.running = false;
          return false;
        }
        if (!this.options.enabled_desktop && window.innerWidth > 767) {
          this.running = false;
          return false;
        }

        // If session storage contains 'hide' don't show notification
        let storage = sessionStorage.getItem('just-bought-notification');
        if (storage == 'hide') {
          this.running = false;
          return false;
        }

        // Wait X seconds to start
        await this.wait(this.options.visible_after_seconds * 1000);

        // Get product data and get random product
        this.products = !this.products ? await this.getProducts() : this.products;
        let product = this.getRandomProduct();

        // Get content
        let city = this.options.cities[Math.floor((Math.random()*this.options.cities.length))],
            heading = (product.heading ? product.heading : this.options.heading).replace('{{ city }}', city),
            alt = product.alt,
            title = product.title,
            url = product.url,
            image = this.formatImage({
              url: product.image,
              alt: product.title,
              size: '92x92',
              class: 'img--square',
              lazy: false
            });

        // Set content
        this.selectors.notification.href = url;
        this.selectors.notification.title = alt;
        this.selectors.heading.innerHTML = heading;
        this.selectors.title.innerHTML = title;
        this.selectors.image.innerHTML = image;

        // Animate in
        this.selectors.notification.classList.add('just-bought-notification--active');

        // Wait X seconds to animate out
        await this.wait(this.options.seconds_visible * 1000);

        // Animate out
        this.selectors.notification.classList.remove('just-bought-notification--active');

        // Start again
        this.loop();

      }

      /**
       * Close popup and remember for session
       */
      close() {
        this.selectors.notification.classList.remove('just-bought-notification--active');
        sessionStorage.setItem('just-bought-notification', 'hide');
      }

    }

    window.JustBoughtNotification = JustBoughtNotification;

    customElements.define('just-bought-notification', JustBoughtNotification);

  }

})();
